<div class="flex flex-col md:flex-row md:items-center md:gap-3 gap-1">
  <div class="w-48 shrink-0">
    <button
      class="mode-button shrink-0 w-40 h-12"
      [ngClass]="{ 'active-mode': selected }"
      [attr.data-tour]="'preset-type-' + type.value"
      (click)="updatePreset(preset, type.value)"
      [disabled]="preset.is_default"
      [class.disabled]="preset.is_default">
      {{ type.label }}
    </button>
  </div>
  <span class="text-sm text-night-lighter flex flex-wrap items-center" [ngClass]="{ '!text-grass-darker': selected }">
    <span>{{ description.beforeTiming }}</span>
    <span class="inline-block mx-1" *ngIf="description.hasTiming">
      <button
        mat-flat-button
        class="filter__option-btn button__small button__text"
        style="background-color: #f8f7f9"
        [matMenuTriggerFor]="timingMenu">
        <span>
          {{ timingButtonLabel }}
        </span>
      </button>
    </span>
    <span>{{ description.afterTiming }}</span>
  </span>
</div>

<mat-menu #timingMenu="matMenu" class="filters__cdk-menu" (closed)="updatePreset(preset, type.value)">
  <ng-template matMenuContent>
    <mat-radio-group fxLayout="column" class="filters__input-number-rg" [formControl]="timingUnitCtrl">
      <ng-container *ngFor="let unit of units">
        <mat-radio-button [value]="unit.value" (click)="$event.stopPropagation()">
          {{ unit.label }}
        </mat-radio-button>
        <mat-form-field
          *ngIf="unit.value === timingUnitCtrl.value && unit.value !== null"
          (click)="$event.stopPropagation()">
          <input matInput type="number" [formControl]="timingValueCtrl" />
        </mat-form-field>
      </ng-container>
    </mat-radio-group>

    <button class="filter__btn-done">Done</button>
  </ng-template>
</mat-menu>
